import "admin/src/style/videoMetadataPage.css";
import { _ } from "i18n";
import client from "libs/client";
import { useLocation, useNavigate } from "react-router";
import { useToast } from "ui-kit";
import { getVideoUploadErrorMessage } from "./videoUploadErrors";

interface ResetModalProps {
    videoId: number;
    close: () => void;
}

export function ResetModal({ videoId, close }: ResetModalProps) {
    const { addSuccessToast, addErrorToast } = useToast();
    const navigate = useNavigate();
    const location = useLocation();

    const resetMutation = client.videoProcessingReset.useMutation({
        onSuccess: () => {
            addSuccessToast("video processing has been reset");
            client.queryClient.invalidateQueries({
                predicate: (query) => query.queryKey.includes("metadataVideos"),
            });
            if (location.pathname !== "/video-uploads/errored") {
                navigate("/video-uploads/errored")
            }
            close();
        },
        onError: (res) => addErrorToast(getVideoUploadErrorMessage(res)),
    });

    const onSubmit = () => {
        resetMutation.mutate({ id: videoId })
    };

    return (
        <div className="approveVideoModal-container">
            <div className="approveMessage">
                Are you sure you want to reset video status?
            </div>
            <div className="buttons">
                <div className="submit" onClick={() => onSubmit()}>
                    Reset
                </div>
                <div className="cancel" onClick={() => close()}>
                    Cancel
                </div>
            </div>
        </div>
    );
}
